import * as Sentry from "@sentry/react";

if (process.env.REACT_APP_URL === "https://clear.loans") {
  Sentry.init({
    dsn: "https://bdd6a93fe3129f1df88e3317ae9ff10f@o4509553850712064.ingest.us.sentry.io/4509553851629568",
    // Adds request headers and IP for users, for more info visit:
    // https://docs.sentry.io/platforms/javascript/guides/react/configuration/options/#sendDefaultPii
    sendDefaultPii: false,
    integrations: [],
  });
}
